import Immutable from 'immutable';

export default Immutable.fromJS({
  creditsAvailable: [],
  creditBalance: null,
  creditTransactions: [],
});
